import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), [setMounted]);

  const active = mounted ? resolvedTheme || theme : "light";
  const isDark = active === "dark";

  const toggle = () => setTheme(isDark ? "light" : "dark");

  return (
    <div className="fixed bottom-6 left-6 z-50">
      <button
        data-testid="theme-toggle"
        onClick={toggle}
        aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
        title={`Switch to ${isDark ? "light" : "dark"} mode`}
        className="group relative inline-flex items-center gap-2 h-11 pl-2 pr-4 bg-white dark:bg-black border-2 border-black dark:border-white text-black dark:text-white font-mono text-xs uppercase tracking-widest shadow-[4px_4px_0_0_rgba(0,0,0,0.9)] dark:shadow-[4px_4px_0_0_rgba(234,179,8,0.6)] hover:shadow-[2px_2px_0_0_rgba(0,0,0,0.9)] dark:hover:shadow-[2px_2px_0_0_rgba(234,179,8,0.9)] hover:translate-x-[2px] hover:translate-y-[2px] transition-all"
      >
        <span
          className={`relative w-7 h-7 grid place-items-center transition-colors ${
            isDark
              ? "bg-yellow-500 text-black"
              : "bg-black text-yellow-500"
          }`}
        >
          {isDark ? (
            <Moon className="w-3.5 h-3.5" strokeWidth={2.5} />
          ) : (
            <Sun className="w-3.5 h-3.5" strokeWidth={2.5} />
          )}
        </span>
        <span data-testid="theme-toggle-label">
          {isDark ? "Dark" : "Light"}
        </span>
      </button>
    </div>
  );
}
